import { InjectedFormProps, reduxForm, DecoratedFormProps } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { ReactNode, useEffect, useState } from 'react';
import { email, maxDate, maxLength, minDate, required, Validators } from 'src/components/redux-form/utils/validators';
import moment from 'moment';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/cases-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { asyncPersistCase } from 'src/store/actions/case-actions';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { DropZoneField } from 'src/components/DropZoneField';
import { FieldDropdown } from '../../../../../components/redux-form/fields/FieldDropdown';
import InfoItem from '../../../../../components/InfoItem';
import { FieldTextArea } from '../../../../../components/redux-form/fields/FieldTextArea';
import { FieldInputMask } from '../../../../../components/redux-form/fields/FieldInputMask';
import { IOrder } from '../../../../../types/order';
import { IProvider } from '../../../../../types/provider';
import { IServiceType } from '../../../../../types/service-types';
import Loader from '../../../../../components/Loader';
import { useSelector } from 'react-redux';
import { miniLoaderForSelector } from '../../../../../store/selectors/cases-selectors';
import { loaderSelector } from '../../../../../store/selectors/orders-selectors';
import { FieldDate } from '../../../../../components/redux-form/fields/FieldDate';
import { Button, Modal } from 'react-bootstrap';
import { changeToZeroMoment } from '../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../helpers/format';
import { IServiceTypeProvider } from '../../../../../types/service-types-providers';

export interface CaseFormData {
    id: string | number;
    rateAdvances: AnyObject[];
    rateAdvanceValue: string;
    rateAdvanceDate: string;
    isBonused: number | boolean;
    isDatasheetRequired: number | boolean;
    isHideFromCalendar: number | boolean;
    occasionServiceLocations: AnyObject[];
    occasionExternalEvalRates: AnyObject[];
    occasionExternalRates: AnyObject[];
    occasionInternalRates: AnyObject[];
    occasionProviders: AnyObject[];
    caseTypeDropDown: SelectObject | undefined;
    orderTypeDropDown: SelectObject | undefined;
    ordersDropDown: SelectObject | undefined;
    invoiceSignerDropdown: SelectObject | undefined;
    caseStatusDropdown: SelectObject | undefined;
    minPerUnitDropdown: SelectObject | undefined;
    providerDropDown: SelectObject | undefined;
    serviceLocationDropDown: SelectObject | undefined;
    serviceTypeDropDown: SelectObject | undefined;
    serviceTypeProviderDropDown: SelectObject | undefined;
    studentDropDown: SelectObject | undefined;
    districtDropDown: SelectObject | undefined;
    vendorDropDown: SelectObject | undefined;
    principalFullName: string;
    doeEmail: string;
    serviceLocationDate: string;
    providerDropDownDate: string;
    principalPrimeEmail: string;
    principalSecondaryEmail: string;
    principalPhone: string;
    serviceTypeDescription: string;
    totalHoursWorked: number;
    allocatedHours: number;
    externalRatePerHour: number;
    externalRatePerHourDate: number;
    internalRatePerHour: string;
    internalRatePerHourDate: string;
    externalEvalHourlyRateDate: string;
    caseNumber: string;
    openingBalance: number;
    credit: number;
    serviceType: string;
    serviceTypeCpt: any;
    serviceTypeProvider: SelectObject | undefined;
    student: string | null;
    diagnosis: string;
    externalEvalHourlyRate: number;
    caseNumberValidityTo: string;
    caseNumberValidityFrom: string;
    exigentBonusStartFrom: string;
    invoiceStartNumber: number;
    program: string | number;
    note: string;
}

interface CaseFormProps {
    files: any;
    valuesForm: any;
    minPerUnitValues: SelectObject[];
    statusValues: SelectObject[];
    invoiceSignerValues: SelectObject[];
    serviceTypeProviderValues: SelectObject[];
    serviceLocations: Partial<IOrder>[];
    providers: Partial<IProvider>[];
    students: SelectObject[];
    districts: SelectObject[];
    vendors: SelectObject[];
    serviceTypes: Partial<IServiceType>[];
    caseTypeValue: string | number;
    invoiceSignerValue: string | number;
    statusItemValue: string | number;
    serviceTypeProviderValue: string | number;
    status?: string | number;
    infoEntity: { [key: string]: string };
    numberOfHoursBilled: string;
    orderTypeValue: string | number;
    orderTypes: SelectObject[];
    serviceTypeProviders: SelectObject[];
    OrderValues: SelectObject[];
    caseTypes: SelectObject[];
    setFiles: (it: []) => void;
    dispatch?: any;
    removeFile: (it: any) => void;
    resetDouble: any;
    dataSaveModal: any;
    setSaveModal: any;
    // isUniqueName: any;
    handleCheck: any;
    isDouble: any;
}

type InjectedProps = InjectedFormProps<CaseFormData, CaseFormProps>;

const validators: Validators<CaseFormData> = {
    caseTypeDropDown: [required({ message: 'Case Type is required.' }), maxLength({ max: 255 })],
    providerDropDownDate: [maxLength({ max: 255 })],
    externalEvalHourlyRateDate: [maxLength({ max: 255 })],
    diagnosis: [maxLength({ max: 255 })],
    program: [maxLength({ max: 255 })],
    caseNumberValidityTo: [maxLength({ max: 255 })],
    serviceTypeDescription: [maxLength({ max: 255 })],
    caseNumberValidityFrom: [maxLength({ max: 255 })],
    exigentBonusStartFrom: [
        minDate({
            field: 'caseNumberValidityFrom',
            message: 'Exigent bonus start date cannot be earlier than Case Validity Start.',
        }),
        maxDate({
            field: 'caseNumberValidityTo',
            message: 'Exigent bonus start date cannot be later than Case Validity End.',
        }),
    ],
    externalEvalHourlyRate: [required({ message: 'Eval Hourly Rate is required.' }), maxLength({ max: 255 })],
    serviceTypeDropDown: [maxLength({ max: 255 })],
    serviceTypeProviderDropDown: [required({ message: 'Service Type Provider is required.' }), maxLength({ max: 255 })],
    studentDropDown: [required({ message: 'Student Full Name is required.' }), maxLength({ max: 255 })],
    districtDropDown: [maxLength({ max: 255 })],
    vendorDropDown: [maxLength({ max: 255 })],
    orderTypeDropDown: [required({ message: 'Order Type is required.' }), maxLength({ max: 255 })],
    ordersDropDown: [required({ message: 'Orders are required.' }), maxLength({ max: 255 })],
    principalFullName: [maxLength({ max: 255 }), required({ message: 'Principal Full name is required.' })],
    totalHoursWorked: [maxLength({ max: 255 })],
    principalPrimeEmail: [maxLength({ max: 255 }), email(), required({ message: 'Principal Email is required.' })],
    principalSecondaryEmail: [maxLength({ max: 255 })],
    //principalPhone: [maxLength({ max: 255 })],
    principalPhone: [maxLength({ max: 255 })],
    providerDropDown: [required({ message: 'Provider is required.' }), maxLength({ max: 255 })],
    serviceLocationDropDown: [required({ message: 'Service Location is required.' }), maxLength({ max: 255 })],
    minPerUnitDropdown: [required({ message: 'Min Per Unit is required.' }), maxLength({ max: 255 })],
    externalRatePerHour: [maxLength({ max: 255 })],
    internalRatePerHour: [maxLength({ max: 255 })],
    caseNumber: [maxLength({ max: 255 })],
    openingBalance: [maxLength({ max: 255 })],
    credit: [maxLength({ max: 255 })],
    invoiceSignerDropdown: [maxLength({ max: 255 }), required({ message: 'Invoice Signer is required.' })],
    invoiceStartNumber: [maxLength({ max: 255 })],
    caseStatusDropdown: [required({ message: 'Status is required.' }), maxLength({ max: 255 })],
    note: [maxLength({ max: 255 })],
};

const CaseForm: React.FunctionComponent<InjectedProps & CaseFormProps> = ({
    handleSubmit,
    change,
    error,
    invalid,
    status,
    files,
    setFiles,
    caseTypes,
    orderTypes,
    OrderValues,
    removeFile,
    serviceLocations,
    minPerUnitValues,
    statusValues,
    invoiceSignerValues,
    providers,
    students,
    districts,
    vendors,
    infoEntity,
    caseTypeValue,
    invoiceSignerValue,
    serviceTypes,
    serviceTypeProviders,
    serviceTypeProviderValues,
    orderTypeValue,
    statusItemValue,
    initialValues,
    valuesForm,
    setSaveModal,
    dataSaveModal,
    resetDouble,
    isDouble,
    handleCheck,
}: InjectedProps & CaseFormProps) => {
    let rateAdvances: any[] = [];

    const [dataModal, setModal] = useState(false);
    const isNew = !initialValues || !initialValues.id;
    const statusInit = initialValues?.caseStatusDropdown?.value ? +initialValues.caseStatusDropdown.value : 0;

    let occasionServiceLocations: AnyObject[] = [];
    let occasionExternalEvalRates: AnyObject[] = [];
    let occasionExternalRates: AnyObject[] = [];
    let occasionInternalRates: AnyObject[] = [];
    let occasionProviders: AnyObject[] = [];
    if (initialValues) {
        occasionServiceLocations = initialValues.occasionServiceLocations ? initialValues.occasionServiceLocations : [];
        occasionExternalEvalRates = initialValues.occasionExternalEvalRates
            ? initialValues.occasionExternalEvalRates
            : [];
        //occasionExternalRates = initialValues.occasionExternalRates ? initialValues.occasionExternalRates : [];
        //occasionInternalRates = initialValues.occasionInternalRates ? initialValues.occasionInternalRates : [];
        occasionProviders = initialValues.occasionProviders ? initialValues.occasionProviders : [];
        rateAdvances = initialValues.rateAdvances
            ? !Array.isArray(initialValues.rateAdvances)
                ? Object.values(initialValues.rateAdvances)
                : initialValues.rateAdvances
            : [];

        occasionInternalRates = initialValues.occasionInternalRates
            ? !Array.isArray(initialValues.occasionInternalRates)
                ? Object.values(initialValues.occasionInternalRates)
                : initialValues.occasionInternalRates
            : [];

        occasionExternalRates = initialValues.occasionExternalRates
            ? !Array.isArray(initialValues.occasionExternalRates)
                ? Object.values(initialValues.occasionExternalRates)
                : initialValues.occasionExternalRates
            : [];
    }

    const serviceLocationValues: SelectObject[] = [];
    serviceLocations.forEach((itLoc: any) => {
        serviceLocationValues.push({ value: itLoc.id, label: `${itLoc.title}` });
    });

    const providerValues: SelectObject[] = [];
    providers.forEach((prov: Partial<IProvider>) => {
        providerValues.push({ value: prov.id, label: `${prov.fullName}` });
    });
    providerValues.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    const serviceTypesValues: any = [];
    const CPTValues: any = [];
    if (+orderTypeValue === 4) {
        serviceTypes.forEach((stype: Partial<IServiceType>) => {
            //if (stype.isEvaluation) {
            const labelArr = [];
            if (stype.title) {
                labelArr.push(stype.title);
            }
            if (stype.cpt) {
                labelArr.push(`CPT: [${stype.cpt}]`);
            }
            const label = labelArr.join(', ');
            serviceTypesValues.push({ value: stype.id, cpt: `${stype.cpt ? stype.cpt : ''}`, label });
            if (stype.cpt) {
                CPTValues.push({ value: stype.id, cpt: `${stype.cpt}`, label: `${stype.cpt}` });
            }
            // }
        });
    } else {
        serviceTypes.forEach((stype: Partial<IServiceType>) => {
            const labelArr = [];
            if (stype.title) {
                labelArr.push(stype.title);
            }
            if (stype.cpt) {
                labelArr.push(`CPT: [${stype.cpt}]`);
            }
            const label = labelArr.join(', ');
            serviceTypesValues.push({ value: stype.id, cpt: `${stype.cpt ? stype.cpt : ''}`, label });
            if (stype.cpt) {
                CPTValues.push({ value: stype.id, cpt: `${stype.cpt}`, label: `${stype.cpt}` });
            }
        });
    }

    const {
        caseAuthorizationValue,
        caseNumberValue,
        caseAuthorizationSourceValue,
        caseNumberValidityValue,
        AllocatedHoursPerValue,
        NumberHoursAllocatedValue,
        MoneyAllocatedValue,
        ServiceTypeValue,
        studentFullNameValue,
        studentId,
        serviceTypeProviderValue,
    } = infoEntity;

    const showPublic: number = +caseTypeValue === 1 || +caseTypeValue === 5 ? 1 : 0;

    // Exigent bonus start date is only meaningful for bonused cases and must fall
    // within the case validity range [caseNumberValidityFrom, caseNumberValidityTo].
    const exigentBonusEnabled = !!valuesForm?.isBonused;
    const exigentBonusMin = valuesForm?.caseNumberValidityFrom
        ? moment(valuesForm.caseNumberValidityFrom).toDate()
        : undefined;
    const exigentBonusMax = valuesForm?.caseNumberValidityTo
        ? moment(valuesForm.caseNumberValidityTo).toDate()
        : undefined;

    // Default the start date to Case Validity Start when the case becomes bonused
    // and the field has not been set yet (backend applies the same default).
    useEffect(() => {
        if (exigentBonusEnabled && !valuesForm?.exigentBonusStartFrom && valuesForm?.caseNumberValidityFrom) {
            change('exigentBonusStartFrom', valuesForm.caseNumberValidityFrom);
        }
    }, [exigentBonusEnabled, valuesForm?.caseNumberValidityFrom, valuesForm?.exigentBonusStartFrom]);

    // Both case validity dates are mandatory for every case type except Draft — the backend skips
    // validation for drafts (OccasionGroupsGenerator), so the form must not block saving one.
    const isDraftCase = +statusItemValue === 3;
    const caseNumberValidityFromValidators = React.useMemo(
        () =>
            isDraftCase
                ? validators.caseNumberValidityFrom ?? []
                : [...(validators.caseNumberValidityFrom ?? []), required({ message: 'Start date is required.' })],
        [isDraftCase],
    );
    const caseNumberValidityToValidators = React.useMemo(
        () =>
            isDraftCase
                ? validators.caseNumberValidityTo ?? []
                : [...(validators.caseNumberValidityTo ?? []), required({ message: 'End date is required.' })],
        [isDraftCase],
    );

    const loaderSelectorOrders = useSelector(loaderSelector);
    const publicCase = (
        <div className={classNames(styles.paddingWrap)}>
            <div className={'position-relative'}>
                {loaderSelectorOrders ? <Loader /> : null}
                <FieldDropdown
                    name="ordersDropDown"
                    data={OrderValues}
                    textField={'label'}
                    valueField={'value'}
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={validators.ordersDropDown}
                    wrapperConfig={{
                        label: 'Orders *',
                    }}
                />
            </div>
            <div className={'d-flex flex-row'}>
                <div className="w-50">
                    <InfoItem title={'Student Full Name:'} value={studentFullNameValue} />
                </div>
                <div className="w-50">
                    <InfoItem title={'Service Type Provider:'} value={serviceTypeProviderValue} />
                </div>
                {studentId ? (
                    <FieldInput
                        name="student"
                        disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                        type="hidden"
                        value={`${studentId}`}
                        validate={validators.principalFullName}
                        wrapperConfig={{
                            label: '',
                        }}
                    />
                ) : null}
            </div>

            <div className="d-flex flex-row">
                <div className="w-50">
                    <InfoItem title={'Case Number:'} value={caseNumberValue} />
                </div>
                <div className="w-50">
                    <InfoItem title={'Case Number Validity:'} value={caseNumberValidityValue} />
                </div>
            </div>
            <div className="d-flex flex-row">
                <div className="w-50">
                    <InfoItem title={'Authorization Date:'} value={caseAuthorizationValue} />
                </div>
                <div className="w-50">
                    <InfoItem title={'Authorization Source:'} value={caseAuthorizationSourceValue} />
                </div>
            </div>
            <div className="d-flex flex-row">
                {showPublic && (+orderTypeValue === 1 || +orderTypeValue === 6) ? (
                    <div className="w-50">
                        <InfoItem
                            title={'Allocated Hours per:'}
                            value={AllocatedHoursPerValue && AllocatedHoursPerValue}
                        />
                    </div>
                ) : null}
                {showPublic && +orderTypeValue !== 4 ? (
                    <div className="w-50 ">
                        <InfoItem
                            title={'Number of hours allocated, hrs:'}
                            value={NumberHoursAllocatedValue && `${NumberHoursAllocatedValue} hrs`}
                        />
                    </div>
                ) : null}
                {showPublic && +orderTypeValue === 3 ? (
                    <div className="w-50">
                        <InfoItem
                            title={'Amount of money allocated, $:'}
                            value={MoneyAllocatedValue ? `$${numberWithCommas(MoneyAllocatedValue)}` : '$0.00'}
                        />
                    </div>
                ) : null}
            </div>
            <div className="w-100">
                <InfoItem title={'Service Type:'} value={ServiceTypeValue} />
            </div>
        </div>
    );
    const studentDropDownData = (
        <div className={'w-100'}>
            {' '}
            <FieldDropdown
                name="studentDropDown"
                data={students}
                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                textField={'label'}
                valueField={'value'}
                validate={validators.studentDropDown}
                wrapperConfig={{
                    label: 'Student Full Name *',
                }}
            />
        </div>
    );

    const studentForDistrictDropDownData = (
        <div className={'w-100'}>
            {' '}
            <FieldDropdown
                name="studentDropDown"
                data={students}
                textField={'label'}
                valueField={'value'}
                wrapperConfig={{
                    label: 'Student Full Name',
                }}
            />
        </div>
    );

    const VendorDropDownData = (
        <div className={'w-100'}>
            <FieldDropdown
                name="vendorDropDown"
                data={vendors}
                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                textField={'label'}
                valueField={'value'}
                validate={validators.vendorDropDown}
                wrapperConfig={{
                    label: 'Vendor Name *',
                }}
            />
        </div>
    );

    const districtDropDownData = (
        <div className={'w-100'}>
            <FieldDropdown
                name="districtDropDown"
                data={districts}
                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                textField={'label'}
                valueField={'value'}
                validate={validators.districtDropDown}
                wrapperConfig={{
                    label: 'District Name *',
                }}
            />
        </div>
    );

    const dropDownData: any = {
        2: studentDropDownData,
        4: VendorDropDownData,
        3: districtDropDownData,
    };

    const privateForm = (
        <div>
            <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                <div className={'row'}>
                    <div className="col-md-6">{dropDownData[+caseTypeValue]}</div>
                    <div className="col-md-6">
                        <FieldDropdown
                            name="serviceTypeProviderDropDown"
                            data={serviceTypeProviderValues}
                            textField={'label'}
                            valueField={'value'}
                            validate={validators.serviceTypeProviderDropDown}
                            wrapperConfig={{
                                label: 'Service Type Provider *',
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                <div className="row">
                    <div className="col-md-6">{caseTypeValue === 3 ? studentForDistrictDropDownData : null}</div>
                    <div className="col-md-6">
                        {caseTypeValue === 3 ? (
                            <div className={'w-100'}>
                                {' '}
                                <FieldDropdown
                                    name="minPerUnitDropdown"
                                    data={minPerUnitValues}
                                    textField={'label'}
                                    valueField={'value'}
                                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                    validate={validators.minPerUnitDropdown}
                                    wrapperConfig={{
                                        label: 'Min per Unit *',
                                    }}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                <div className="row">
                    <div className="col-md-6">
                        <FieldDropdown
                            name="serviceTypeDropDown"
                            disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                            data={serviceTypesValues}
                            textField={'label'}
                            valueField={'value'}
                            validate={validators.serviceTypeDropDown}
                            wrapperConfig={{
                                label: 'Service Type *',
                            }}
                        />
                    </div>
                    <div className="col-md-6">
                        <FieldDropdown
                            name="serviceTypeDropDown"
                            data={CPTValues}
                            disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                            textField={'cpt'}
                            valueField={'value'}
                            validate={validators.serviceTypeDropDown}
                            wrapperConfig={{
                                label: 'CPT',
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                <div className="row">
                    <div className="col-md-6">
                        <div>
                            {caseTypeValue === 1 ? 'Case Number Validity | From *' : 'Session date range | From *'}
                        </div>
                        <FieldDate
                            name="caseNumberValidityFrom"
                            type="text"
                            date={true}
                            className="mr-5"
                            validate={caseNumberValidityFromValidators}
                            wrapperConfig={{
                                label: '',
                                classes: {},
                            }}
                        />
                    </div>

                    <div className="col-md-6">
                        <FieldDate
                            name="caseNumberValidityTo"
                            type="text"
                            date={true}
                            validate={caseNumberValidityToValidators}
                            wrapperConfig={{
                                label: 'To *',
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
    const typesForm: { [key: number]: ReactNode } = {
        1: publicCase,
        0: privateForm,
    };
    const miniLoaderFor = useSelector(miniLoaderForSelector);
    const handleSub = (event: any) => {
        if (statusItemValue !== status && statusItemValue === 2) {
            event.preventDefault();
            setModal(true);
        }
    };

    // The duplicate lookup used to run straight off the button click, so an incomplete form opened the
    // "another case already exists" dialog instead of showing its own errors. Submitting first makes
    // redux-form touch every field and stop on the sync errors; only a valid form reaches the check.
    const handleCheckOrShowErrors = (event: any) => {
        if (invalid) {
            handleSubmit(event);

            return;
        }

        handleCheck(event);
    };

    const simulateClick = (e: any) => {
        if (isDouble == 'no') {
            setTimeout(() => {
                e?.click();
                resetDouble();
            }, 500);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit} className={classNames(styles.form)}>
                <FormError error={error} />
                <FieldInput
                    name="id"
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />

                <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                    <div className="row">
                        <div className="col-md-6">
                            <FieldDropdown
                                name="caseTypeDropDown"
                                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                data={caseTypes}
                                textField={'label'}
                                valueField={'value'}
                                validate={validators.caseTypeDropDown}
                                wrapperConfig={{
                                    label: 'Case Type *',
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <FieldDropdown
                                name="orderTypeDropDown"
                                data={orderTypes}
                                textField={'label'}
                                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                valueField={'value'}
                                validate={validators.orderTypeDropDown}
                                wrapperConfig={{
                                    label: 'Order Type *',
                                }}
                            />
                        </div>
                    </div>
                </div>

                {typesForm[showPublic]}

                <div className="rowFieldswithList">
                    {occasionProviders.map((itA: any, l) => (
                        <div style={{ display: 'flex' }} key={`k${l}`}>
                            <InfoItem
                                title={''}
                                value={`${itA.provider?.fullName} -  ${
                                    itA.createdAt ? changeToZeroMoment(itA.createdAt, 'MMM D, YYYY') : null
                                }`}
                            />
                            <InfoItem
                                title={''}
                                value={`${itA?.serviceTypeDescription ? ' ' + itA?.serviceTypeDescription : ''}`}
                            />
                        </div>
                    ))}
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Provider Full Name {isNew ? '*' : null}</label>
                                <FieldDropdown
                                    name="providerDropDown"
                                    data={providerValues}
                                    textField={'label'}
                                    valueField={'value'}
                                    validate={isNew ? validators.providerDropDown : undefined}
                                    wrapperConfig={{
                                        label: '',
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <FieldDate
                                    name="providerDropDownDate"
                                    type="text"
                                    date={true}
                                    validate={validators.providerDropDownDate}
                                    wrapperConfig={{
                                        label: 'From',
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <FieldInput
                                    name="serviceTypeDescription"
                                    type="text"
                                    validate={validators.serviceTypeDescription}
                                    wrapperConfig={{
                                        label: 'Service Type Description ',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rowFieldswithList">
                    {occasionServiceLocations.map((itA: any, l) => (
                        <div key={`k${l}`}>
                            <InfoItem
                                title={''}
                                value={`${itA.serviceLocation?.title} -  ${
                                    itA.createdAt ? changeToZeroMoment(itA.createdAt, 'MMM D, YYYY') : null
                                }`}
                            />
                        </div>
                    ))}
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Service Location {isNew ? '*' : null}</label>
                                <FieldDropdown
                                    name="serviceLocationDropDown"
                                    data={serviceLocationValues}
                                    textField={'label'}
                                    valueField={'value'}
                                    validate={isNew ? validators.serviceLocationDropDown : undefined}
                                    wrapperConfig={{
                                        label: '',
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <FieldDate
                                    name="serviceLocationDate"
                                    type="text"
                                    date={true}
                                    validate={validators.serviceLocationDate}
                                    wrapperConfig={{
                                        label: ' From',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {showPublic ? (
                    <div className={classNames(styles.paddingWrap)}>
                        <FieldInput
                            name="principalFullName"
                            type="text"
                            validate={
                                (valuesForm === undefined ||
                                    !valuesForm.invoiceSignerDropdown ||
                                    !valuesForm.invoiceSignerDropdown.value ||
                                    valuesForm.invoiceSignerDropdown.value == 1) &&
                                validators.principalFullName
                                    ? [validators.principalFullName[0]]
                                    : validators.principalFullName
                            }
                            wrapperConfig={{
                                label:
                                    'Principal Full Name' +
                                    (valuesForm &&
                                    valuesForm.invoiceSignerDropdown &&
                                    valuesForm.invoiceSignerDropdown.value != 1
                                        ? ' * '
                                        : ' '),
                            }}
                        />
                        <FieldInput
                            name="principalPrimeEmail"
                            type="text"
                            validate={
                                (valuesForm === undefined ||
                                    !valuesForm.invoiceSignerDropdown ||
                                    !valuesForm.invoiceSignerDropdown.value ||
                                    valuesForm.invoiceSignerDropdown.value == 1) &&
                                validators.principalPrimeEmail
                                    ? [validators.principalPrimeEmail[0], validators.principalPrimeEmail[1]]
                                    : validators.principalPrimeEmail
                            }
                            wrapperConfig={{
                                label:
                                    'Principal Primary Email' +
                                    (valuesForm &&
                                    valuesForm.invoiceSignerDropdown &&
                                    valuesForm.invoiceSignerDropdown.value != 1
                                        ? ' * '
                                        : ' '),
                            }}
                        />
                        <FieldInput
                            name="principalSecondaryEmail"
                            type="text"
                            validate={validators.principalSecondaryEmail}
                            wrapperConfig={{
                                label: 'Principal Secondary Email(s)',
                            }}
                        />
                        <FieldInputMask
                            mask={'+1 999-999-9999'}
                            name="principalPhone"
                            type="phone"
                            validate={validators.principalPhone}
                            wrapperConfig={{
                                label: 'Principal Phone Number',
                            }}
                        />
                    </div>
                ) : null}
                {!showPublic && caseTypeValue !== 3 && caseTypeValue !== 2 && caseTypeValue !== 4 ? (
                    <div className={classNames(styles.paddingWrap)}>
                        <FieldInput
                            name="diagnosis"
                            type="text"
                            validate={validators.diagnosis}
                            wrapperConfig={{
                                label: 'Diagnosis',
                            }}
                        />
                    </div>
                ) : null}
                {caseTypeValue === 1 ? (
                    <div className={classNames(styles.paddingWrap)}>
                        <FieldInput
                            name="doeEmail"
                            type="text"
                            wrapperConfig={{
                                label: 'Doe email(NPS/Settlement)',
                            }}
                        />
                    </div>
                ) : null}
                {caseTypeValue === 5 ? (
                    <div className={classNames(styles.paddingWrap)}>
                        <FieldInput
                            name="poNumber"
                            type="text"
                            wrapperConfig={{
                                label: 'Po Number',
                            }}
                        />
                    </div>
                ) : null}
                {caseTypeValue !== 3 && caseTypeValue !== 2 && caseTypeValue !== 4 ? (
                    <div className={classNames(styles.paddingWrap)}>
                        <FieldDropdown
                            name="minPerUnitDropdown"
                            data={minPerUnitValues}
                            textField={'label'}
                            valueField={'value'}
                            disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                            validate={validators.minPerUnitDropdown}
                            wrapperConfig={{
                                label: 'Min per Unit *',
                            }}
                        />
                    </div>
                ) : null}
                {+orderTypeValue === 4 ? (
                    <div className="rowFieldswithList">
                        {occasionExternalEvalRates.map((itA: any, l) => (
                            <div key={`k${l}`}>
                                <InfoItem
                                    title={''}
                                    value={`$${
                                        itA.externalEvalHourlyRate
                                            ? numberWithCommas(itA.externalEvalHourlyRate)
                                            : '0.00'
                                    } ${itA.createdAt ? changeToZeroMoment(itA.createdAt, 'MMM D, YYYY') : null}`}
                                />
                            </div>
                        ))}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>
                                        {+orderTypeValue === 4
                                            ? 'External Flat Rate (for billing)'
                                            : 'Eval Hourly Rate'}
                                    </label>
                                    <FieldInput
                                        name="externalEvalHourlyRate"
                                        type="number"
                                        validate={validators.externalEvalHourlyRate}
                                        wrapperConfig={{
                                            label: '',
                                        }}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <FieldDate
                                        name="externalEvalHourlyRateDate"
                                        type="text"
                                        date={true}
                                        validate={validators.externalEvalHourlyRateDate}
                                        wrapperConfig={{
                                            label: 'From',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                <div className="rowFieldswithList">
                    {occasionExternalRates.map((itA: any, l) => (
                        <div key={`k${l}`}>
                            <InfoItem
                                title={''}
                                value={`$${
                                    itA.externalRatePerHour ? numberWithCommas(itA.externalRatePerHour) : '0.00'
                                }  -  ${itA.createdAt ? changeToZeroMoment(itA.createdAt, 'MMM D, YYYY') : null}`}
                            />
                        </div>
                    ))}
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    {+orderTypeValue === 4 ? 'Eval Hourly Rate' : 'External Flat Rate (for billing)'}
                                </label>
                                <FieldInput
                                    name="externalRatePerHour"
                                    type="number"
                                    validate={validators.externalRatePerHour}
                                    wrapperConfig={{
                                        label: '',
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <FieldDate
                                    name="externalRatePerHourDate"
                                    type="text"
                                    date={true}
                                    validate={validators.externalRatePerHourDate}
                                    wrapperConfig={{
                                        label: 'From',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rowFieldswithList">
                    {occasionInternalRates.map((itA: any, l) => (
                        <div key={`k${l}`}>
                            <InfoItem
                                title={''}
                                value={`$${
                                    itA.internalRatePerHour ? numberWithCommas(itA.internalRatePerHour) : '0.00'
                                }  -  ${itA.createdAt ? changeToZeroMoment(itA.createdAt, 'MMM D, YYYY') : null}`}
                            />
                        </div>
                    ))}
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Internal Flat Rate (for payroll)</label>
                                <FieldInput
                                    name="internalRatePerHour"
                                    type="number"
                                    validate={isNew ? validators.internalRatePerHour : undefined}
                                    wrapperConfig={{
                                        label: '',
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <FieldDate
                                    name="internalRatePerHourDate"
                                    type="text"
                                    date={true}
                                    validate={isNew ? validators.internalRatePerHourDate : undefined}
                                    wrapperConfig={{
                                        label: 'From',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rowFieldswithList">
                    {rateAdvances.map((itA: any, l) => (
                        <div key={`k${l}`}>
                            <InfoItem
                                title={''}
                                value={`$${numberWithCommas(itA.rateForAdvance)} -  ${
                                    itA.createdAt ? changeToZeroMoment(itA.createdAt, 'MMM D, YYYY') : null
                                }`}
                            />
                        </div>
                    ))}
                    <div className="container-fluid">
                        <div className="row" style={{ alignItems: 'flex-end' }}>
                            <div className="col-md-6">
                                <label>Rate for Advance per Hour, $</label>
                                <FieldInput
                                    name="rateAdvanceValue"
                                    type="number"
                                    wrapperConfig={{
                                        label: '',
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <FieldDate
                                    name="rateAdvanceDate"
                                    type="text"
                                    date={true}
                                    wrapperConfig={{
                                        label: 'From',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {caseTypeValue === 4 ? (
                    <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                        <div className="row">
                            <div className="col-md-6">
                                <FieldDropdown
                                    name="minPerUnitDropdown"
                                    data={minPerUnitValues}
                                    textField={'label'}
                                    valueField={'value'}
                                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                    validate={validators.minPerUnitDropdown}
                                    wrapperConfig={{
                                        label: 'Min per Unit *',
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <FieldInput
                                    name="program"
                                    type="text"
                                    validate={validators.program}
                                    wrapperConfig={{
                                        label: 'Program *',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
                {+orderTypeValue === 4 ? (
                    <div className={classNames(styles.paddingWrap)}>
                        <div className="row">
                            <div className="col-md-6">
                                <FieldInput
                                    name="allocatedHours"
                                    disabled={!isNew}
                                    type="number"
                                    wrapperConfig={{
                                        label: 'Allocated Hours',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
                <div
                    className="container-fluid"
                    style={{ paddingRight: '25px', paddingLeft: '25px', paddingTop: '20px' }}
                >
                    <div className="row" style={{ alignItems: 'flex-end' }}>
                        <div className="col-md-6">
                            {showPublic ? (
                                <div>
                                    <FieldDropdown
                                        name="invoiceSignerDropdown"
                                        data={invoiceSignerValues}
                                        textField={'label'}
                                        valueField={'value'}
                                        validate={
                                            (valuesForm === undefined ||
                                                !valuesForm.caseTypeDropDown ||
                                                valuesForm.caseTypeDropDown.value != 1) &&
                                            validators.invoiceSignerDropdown
                                                ? [validators.invoiceSignerDropdown[0]]
                                                : validators.invoiceSignerDropdown
                                        }
                                        wrapperConfig={{
                                            label:
                                                'Invoice Signer' +
                                                (valuesForm !== undefined &&
                                                valuesForm.caseTypeDropDown &&
                                                valuesForm.caseTypeDropDown.value == 1
                                                    ? ' * '
                                                    : ' '),
                                        }}
                                    />
                                </div>
                            ) : null}

                            {!showPublic && (caseTypeValue === 3 || caseTypeValue === 2 || caseTypeValue === 4) ? (
                                <div>
                                    <FieldInput
                                        name="diagnosis"
                                        type="text"
                                        validate={validators.diagnosis}
                                        wrapperConfig={{
                                            label: 'Diagnosis',
                                        }}
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            {(caseTypeValue === 1 || caseTypeValue === 5 || caseTypeValue === 2) ? (
                                <div className={classNames(styles.isBonusedCheckbox)}>
                                    <FieldInput
                                        name="isBonused"
                                        type="checkbox"
                                        wrapperConfig={{
                                            label: 'Is Exigent Bonus applied?',
                                            classes: {
                                                inputWrapper: 'customCheckbox',
                                            },
                                        }}
                                    />
                                </div>
                            ) : null}
                            {(caseTypeValue === 1 || caseTypeValue === 5 || caseTypeValue === 2) && exigentBonusEnabled ? (
                                <div style={{ marginBottom: '40px' }}>
                                    <div>Exigent bonus start date</div>
                                    <FieldDate
                                        name="exigentBonusStartFrom"
                                        type="text"
                                        date={true}
                                        min={exigentBonusMin}
                                        max={exigentBonusMax}
                                        validate={validators.exigentBonusStartFrom}
                                        wrapperConfig={{
                                            label: '',
                                            classes: {},
                                        }}
                                    />
                                </div>
                            ) : null}
                            <div className={classNames(styles.datasheetIcon)}>
                                <FieldInput
                                    name="isDatasheetRequired"
                                    type="checkbox"
                                    wrapperConfig={{
                                        label: 'Require Data Sheet',
                                        classes: {
                                            inputWrapper: 'customCheckbox',
                                        },
                                    }}
                                />
                            </div>
                            <div className={classNames(styles.datasheetIcon)}>
                                <FieldInput
                                    name="isHideFromCalendar"
                                    type="checkbox"
                                    wrapperConfig={{
                                        label: 'Don\'t show in the cases dropdown on the Calendar',
                                        classes: {
                                            inputWrapper: 'customCheckbox',
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {caseTypeValue === 2 ? (
                    <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                        <div className="row">
                            <div className="col-md-6">
                                <FieldDropdown
                                    name="caseStatusDropdown"
                                    data={statusValues}
                                    textField={'label'}
                                    valueField={'value'}
                                    validate={validators.caseStatusDropdown}
                                    wrapperConfig={{
                                        label: 'Case Status *',
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <FieldDropdown
                                    name="minPerUnitDropdown"
                                    data={minPerUnitValues}
                                    textField={'label'}
                                    valueField={'value'}
                                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                    validate={validators.minPerUnitDropdown}
                                    wrapperConfig={{
                                        label: 'Min per Unit *',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}

                {caseTypeValue !== 2 ? (
                    <div className={classNames(styles.paddingWrap)}>
                        <FieldDropdown
                            name="caseStatusDropdown"
                            data={statusValues}
                            textField={'label'}
                            valueField={'value'}
                            validate={validators.caseStatusDropdown}
                            wrapperConfig={{
                                label: 'Case Status *',
                            }}
                        />
                    </div>
                ) : null}

                <div className={classNames(styles.paddingWrap)}>
                    <FieldTextArea
                        name="note"
                        validate={validators.note}
                        wrapperConfig={{
                            label: 'Note',
                        }}
                    />
                </div>
                <div className="container-fluid" style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                    <div className={'position-relative'}>
                        {miniLoaderFor['FILE'] ? <Loader noFull={true} /> : null}
                        <DropZoneField
                            files={files}
                            setFiles={setFiles}
                            removeFile={(id: string | number) => removeFile(id)}
                        />
                    </div>
                </div>

                <div className={classNames(styles.actions)} style={{ paddingLeft: '24px' }}>
                    {isNew ? (
                        isDouble === 'no' ? (
                            <button
                                type="submit"
                                onClick={(event) => handleSub(event)}
                                className={classNames('btn', 'btn-success', 'mr-3')}
                                ref={simulateClick}
                            >
                                <FontAwesomeIcon icon={faSave} /> Create
                            </button>
                        ) : (
                            <button
                                type="button"
                                onClick={(event) => handleCheckOrShowErrors(event)}
                                className={classNames('btn', 'btn-success', 'mr-3')}
                            >
                                <FontAwesomeIcon icon={faSave} /> Create
                            </button>
                        )
                    ) : (
                        <button
                            type="submit"
                            onClick={(event) => handleSub(event)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                            ref={simulateClick}
                        >
                            <FontAwesomeIcon icon={faSave} /> Update
                        </button>
                    )}

                    <Link className={classNames('btn', 'btn-danger')} to={Router.generate(routes.CASES_LIST)}>
                        <FontAwesomeIcon icon={faBan} /> Cancel
                    </Link>
                </div>
            </form>
            <Modal
                show={dataModal}
                onHide={() => {
                    setModal(false);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to change status Case to Inactive ?</Modal.Body>
                <Modal.Footer>
                    <form onSubmit={handleSubmit}>
                        <Button
                            className={'mr-2'}
                            variant="secondary"
                            onClick={() => {
                                setModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                setModal(false);
                            }}
                            variant="danger"
                            type="submit"
                        >
                            Yes
                        </Button>
                    </form>
                </Modal.Footer>
            </Modal>

            <Modal
                show={dataSaveModal}
                onHide={() => {
                    setSaveModal(false);
                    resetDouble();
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Another case with the same case number, type, order type, student full name/vendor/district,
                    provider, service type, and service location already exists. Are you sure you want to duplicate it?{' '}
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={handleSubmit}>
                        <Button
                            className={'mr-2'}
                            variant="secondary"
                            onClick={() => {
                                setSaveModal(false);
                                resetDouble();
                            }}
                        >
                            Cancel
                        </Button>
                        <button
                            type="submit"
                            onClick={(event) => handleSub(event)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                        >
                            <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                        </button>
                    </form>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default reduxForm<CaseFormData, CaseFormProps>({
    form: 'case-form',
    enableReinitialize: true,
    onSubmit: async (data: CaseFormData, dispatch: Dispatch<any>, props: CaseFormProps) => {
        await asyncPersistCase({ ...data, student: data.student === '' ? null : data.student }, props.files, dispatch);
    },
    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<CaseFormData, CaseFormProps, string>,
    ) {
        const isNew = !props.initialValues || !props.initialValues.id;

        toast.success(`Case was successfully ${isNew ? 'created' : 'updated'}.`);
    },

    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(CaseForm);
